import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { ThemeProvider } from "next-themes";
import { Toaster } from "sonner";
import { TooltipProvider } from "@components/ui/tooltip";
import { Toaster as ShadcnToaster } from "@components/ui/toaster";
import { queryClient } from "@settings/queryClient";
import { store, persistor } from "@store/index";
import type { ReactNode } from "react";

type ProvidersProps = {
  children: ReactNode;
};

export function Providers({ children }: ProvidersProps) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider
              attribute="class"
              defaultTheme="light"
              enableSystem={false}
              disableTransitionOnChange
              storageKey="alpha-theme"
            >
              <TooltipProvider>
                {children}
                <ShadcnToaster />
                <Toaster
                  position="top-right"
                  richColors
                  closeButton
                  duration={4000}
                />
                <ReactQueryDevtools initialIsOpen={false} />
              </TooltipProvider>
            </ThemeProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}
